import i18next from 'i18next';

export const progressoCurriculo = function () {
    "use strict";

    var $divPanel = '#panel-progresso';
    var $panel = body.find($divPanel);
    var $progressoLista = $panel.find('#progresso-lista');
    var $progressoBox = $panel.find('#progresso-box');

    const _candidaturaPendente = function () {
        const candidatura = localStorage.getItem('candidaturaPendente');
        if (candidatura) {
            return JSON.parse(candidatura);
        }
        return { vagaID: "0" };

    };

    var _listar = function () {
        window.global.loaderPanel.show($divPanel);

        $.ajax({
            type: "GET",
            url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/GetProgresso',
            cache: false,
            success: function (dados) {
                var html = [],
                    styleProgressBar = '',
                    textoComplete = '',
                    textoCompleteBox = i18next.t('progressoTextoCompleteBoxDefault'),
                    textoOpcionalBox = i18next.t('progressoTextoOpcional'),
                    classProgressBar = 'danger',
                    textoBotao = i18next.t('progressoTextoBotaoDefault');

                if (dados.sucesso) {
                    if (dados.progresso.Porcentagem < 51) {
                        styleProgressBar = '#e74c3c';
                        textoComplete = i18next.t('progressoTextoComplete51');
                        classProgressBar = 'danger';
                    } else if (dados.progresso.Porcentagem > 50 && dados.progresso.Porcentagem < 80) {
                        styleProgressBar = '#f58634';
                        textoComplete = i18next.t('progressoTextoComplete80');
                        classProgressBar = 'warning';
                    } else if (dados.progresso.Porcentagem > 79 && dados.progresso.Porcentagem < 90) {
                        styleProgressBar = '#40afdf';
                        textoComplete = i18next.t('progressoTextoComplete90');
                        classProgressBar = 'info';
                    } else if (dados.progresso.Porcentagem > 89 && dados.progresso.Porcentagem < 100) {
                        styleProgressBar = '#5cb85c';
                        textoComplete = i18next.t('progressoTextoComplete100');
                        textoCompleteBox = i18next.t('progressoTextoCompleteBox100');
                        classProgressBar = 'success';
                        textoBotao = i18next.t('progressoTextoBotao100');
                    } else {
                        styleProgressBar = '#5cb85c';
                        textoComplete = i18next.t('progressoTextoCompletePerfeito');
                        textoCompleteBox = i18next.t('progressoTextoCompleteBox100');
                        classProgressBar = 'success';
                        textoBotao = i18next.t('progressoTextoBotao100');
                    }

                    if ($progressoLista.length > 0) {
                        html.push('<div class="panel-body">');
                        //html.push('<small class="text-muted">' + textoCompleteBox + '</small>');
                        //html.push('<p class="mt10">');
                        html.push('<b>' + dados.progresso.Porcentagem + '%</b> <small class="text-muted" style="font-size:10px">' + i18next.t('progressoPerfilCompletado') + '</small> <span class="pull-right hide"></span>');
                        html.push('</p>');
                        html.push('<div class="progress"><div class="progress-bar progress-bar-' + classProgressBar + ' progress-bar-striped" role="progressbar" aria-valuenow="' + dados.progresso.Porcentagem + '" aria-valuemin="0" aria-valuemax="100" style="width: ' + dados.progresso.Porcentagem + '%"><span class="sr-only">' + dados.progresso.Porcentagem + '% ' + i18next.t('progressoCompleto') + '</span></div>');
                        html.push('</div>');
                        html.push('<div class="row">');
                        html.push('<div class="list-group">');
                        html.push('<a href="#panel-pessoais" class="list-group-item"><i class="fa ' + ((!dados.progresso.Cep || !dados.progresso.Logradouro || !dados.progresso.Cidade) ? 'fa-exclamation-circle text-warning' : 'fa-check-circle text-success') + ' mr5"></i> ' + i18next.t('progressoPessoais') + '</a>');
                        html.push('<a href="#panel-objetivo" class="list-group-item"><i class="fa ' + (dados.progresso.Objetivo ? 'fa-check-circle text-success' : 'fa-exclamation-circle text-warning') + ' mr5"></i> ' + i18next.t('progressoObjetivo') + '</a>');
                        html.push('<a href="#panel-sintese" class="list-group-item"><i class="fa ' + (dados.progresso.MiniCurriculo ? 'fa-check-circle text-success' : 'fa-exclamation-circle text-warning') + ' mr5"></i> ' + i18next.t('progressoResumo') + '</a>');

                        html.push('<a href="#panel-formacao" class="list-group-item"><i class="fa ' + (dados.progresso.Formacao ? 'fa-check-circle text-success' : 'fa-exclamation-circle text-warning') + ' mr5"></i> ' + i18next.t('progressoFormacao') + '</a>');
                        html.push('<a href="#panel-experiencia" class="list-group-item"><i class="fa ' + (dados.progresso.Experiencia || dados.progresso.SemExperiencia ? 'fa-check-circle text-success' : 'fa-exclamation-circle text-warning') + ' mr5"></i> ' + i18next.t('progressoExperiencia') + '</a>');
                        html.push('<a href="#panel-curso" class="list-group-item"><i class="fa ' + (dados.progresso.Curso ? 'fa-check-circle text-success' : 'fa-circle-o text-primary') + ' mr5"></i> ' + i18next.t('progressoCursos') + '</a>');
                        html.push('<a href="#panel-idioma" class="list-group-item"><i class="fa ' + (dados.progresso.Idioma ? 'fa-check-circle text-success' : 'fa-circle-o text-primary') + ' mr5"></i> ' + i18next.t('progressoIdimoa') + '</a>');
                        html.push('<a href="#panel-informatica" class="list-group-item"><i class="fa ' + (dados.progresso.Informatica || dados.progresso.SemInformatica ? 'fa-check-circle text-success' : 'fa-circle-o text-primary') + ' mr5"></i> ' + i18next.t('progressoInformatica') + '</a>');
                        html.push('<hr/>');
                        html.push('<small class="list-group-item text-center" style="display:flex;">' + textoOpcionalBox + '</small>');
                        html.push('<a href="#panel-foto" class="list-group-item"><i class="fa ' + (dados.progresso.Foto ? 'fa-check-circle text-success' : 'fa-circle-o text-primary') + ' mr5"></i> ' + i18next.t('progressoFoto') + '</a>');

                        html.push('<a href="#panel-social" class="list-group-item"><i class="fa ' + (dados.progresso.RedeSocial ? 'fa-check-circle text-success' : 'fa-circle-o text-primary') + ' mr5"></i> ' + i18next.t('progressoRedeSocial') + '</a>');
                        html.push('<a href="#panel-diversidade" class="list-group-item list-progress-diversidade"><i class="fa ' + (dados.progresso.Diversidade ? 'fa-check-circle text-success' : 'fa-circle-o text-primary') + ' mr5"></i> ' + i18next.t('progressoDiversidade') + '</a>');
                        html.push('</div></div></div>');
                        $progressoLista.html(html.join(''));
                        $progressoLista.find('a').on('click', function (e) {
                            if ($(this).attr('href') == '#panel-foto') {
                                body.find('.avatar-change').click();
                            } else {
                                goToByScroll($(this).attr('href'));
                            }
                            e.preventDefault();
                        });

                        if ($('#hotSiteEmpresaID').length === 0) {
                            if (dados.progresso.Porcentagem > 64) {
                                $('#btn-download-cv').html('<a href="#" data-toggle="modal" data-target="#modal-download-cv" class="btn btn-primary btn-outline-primary mb10 btn-block"><i class="fa fa-download" aria-hidden="true"></i> ' + i18next.t('progressoBaixarCurriculo') + '</a>');
                            } else {
                                $('#btn-download-cv').html('<a href="#" class="btn btn-primary disabled btn-outline-primary mb10 btn-block"><i class="fa fa-download" aria-hidden="true"></i> ' + i18next.t('progressoBaixarCurriculo') + '</a><small class="text-muted text-center">' + i18next.t('progressoBaixarCurriculoHelp') + '</small>');
                            }
                        }
                        var $boxPendente = body.find('#inscricao-pendente');

                        const candidaturaPendente = _candidaturaPendente();

                        if (candidaturaPendente.vagaID != '0') {
                            var htmlInscricaoPendente = inscricaoPendente.boxHtml(candidaturaPendente.url, candidaturaPendente.titulo, dados.incompleto, candidaturaPendente.vagaID);

                            $boxPendente.html(htmlInscricaoPendente);
                            inscricaoPendente.setClick($boxPendente);

                        } else {
                            $boxPendente.html('');
                        }
                    }
                    else {
                        html.push('<small class="text-muted">' + textoCompleteBox + '</small>');
                        html.push('<p class="mt10">');
                        html.push('<b>' + dados.progresso.Porcentagem + '%</b> <small class="text-muted" style="font-size:10px">' + i18next.t('progressoPerfilCompletado') + '</small> <span class="pull-right hide"><b>4</b> de <b>10</b></span>');
                        html.push('</p>');
                        html.push('<div class="progress"><div class="progress-bar progress-bar-' + classProgressBar + ' progress-bar-striped" role="progressbar" aria-valuenow="' + dados.progresso.Porcentagem + '" aria-valuemin="0" aria-valuemax="100" style="width: ' + dados.progresso.Porcentagem + '%"><span class="sr-only">' + dados.progresso.Porcentagem + '% ' + i18next.t('progressoCompleto') + '</span></div>');

                        html.push('</div>');

                        html.push('<a href="curriculo" class="btn btn-primary btn-block"><i class="fa fa-file-text-o"></i> ' + textoBotao + '</a>');


                        $progressoBox.html(html);
                    }
                }
                window.global.loaderPanel.hide($divPanel);
            },
            error: function () {
                window.global.loaderPanel.hide($divPanel);
            }
        });

    };
    var init = function () {
        _listar();
        return false;
    }

    return init();
};

